import React from "react"

import { Box, Container, Typography } from "@mui/material"
import Head from "next/head"
import Header from "../../components/layout/landing/desktop/app-bar"
import PlansList from "./plans"

// -------------------------------------------|| CLUB - PAGES ||-------------------------------------------------------
const JetClubPlans = () => {
  return (
    <>
      <Header isOtherPages={true} />
      <Head>
        <title>طرح های جت کلاب</title>
      </Head>
      <Container sx={{ mt: "1em" }}>
        <Box display={"flex"} justifyContent={"center"} m={"25px"}>
          <Typography variant='h3'>طرح های جت کلاب</Typography>
        </Box>
        <PlansList />
      </Container>
    </>
  )
}

export default JetClubPlans
